import React from "react";
import { ErrorMessage, FieldHookConfig, useField } from "formik";
import { pipe } from "fp-ts/function";
import * as RA from "fp-ts/ReadonlyArray";

import "./select.scss";

/*
 * Types
 */

export interface Choice {
    readonly id: string;
    readonly value: string;
}

export type FormikSelectProps = {
    readonly id?: string;
    readonly label?: string;
    readonly options: ReadonlyArray<Choice>;
} & FieldHookConfig<string>;

export type SelectProps = {
    readonly id?: string;
    readonly label?: string;
    readonly options: ReadonlyArray<Choice>;
} & React.InputHTMLAttributes<HTMLSelectElement>;

/*
 * Main
 */

export const FormikSelect = (props: FormikSelectProps): React.ReactElement => {
    const { id, label, name, options } = props;
    const [field] = useField(props);

    return (
        <div className="input-wrap">
            <label hidden={!label} htmlFor={id || name}>
                {label ?? label}
            </label>
            <select {...field}>
                {pipe(
                    options,
                    RA.map((opt) => (
                        <option key={opt.id} value={opt.id}>
                            {opt.value}
                        </option>
                    )),
                )}
            </select>
            <div className="input-field-error">
                <ErrorMessage name={field.name} />
            </div>
        </div>
    );
};

export const Select = (props: SelectProps): React.ReactElement => {
    const { id, label, options, ...rest } = props;

    return (
        <div className="input-wrap">
            <label hidden={!label} htmlFor={id}>
                {label ?? label}
            </label>
            <select id={id} {...rest}>
                {pipe(
                    options,
                    RA.map((opt) => (
                        <option key={opt.id} value={opt.id}>
                            {opt.value}
                        </option>
                    )),
                )}
            </select>
        </div>
    );
};
